<template>
	<main class="login-page">
		<div class="ambient ambient-one"></div>
		<div class="ambient ambient-two"></div>

		<div class="console-grid" aria-hidden="true">
			<span v-for="node in 18" :key="node" class="grid-node"></span>
		</div>

		<section class="brand-panel">
			<div class="brand-content">
				<div class="brand-mark">
					<img src="@/assets/img/logo.svg" alt="SabayFlix">
					<span>ប្រព័ន្ធគ្រប់គ្រង</span>
				</div>

				<div class="hero-copy">
					<h1><br><strong>SabayFlix</strong></h1>
				</div>

				<div class="system-status">
					<span class="status-dot"></span>
					<div>
						<strong>សេវាកម្មគ្រប់គ្រងប្រព័ន្ធ</strong>
						<small>សម្រាប់តែបុគ្គលិកដែលមានសិទ្ធិប៉ុណ្ណោះ</small>
					</div>
				</div>
			</div>
		</section>

		<section class="form-panel">
			<div class="login-card">
				<div class="mobile-brand">
					<img src="@/assets/img/logo.svg" alt="SabayFlix">
					<span>អ្នកគ្រប់គ្រង</span>
				</div>

				<div class="form-heading">
					<span class="form-kicker">សូមស្វាគមន៍ការត្រឡប់មកវិញ</span>
					<h2>ចូលក្នុងប្រព័ន្ធគ្រប់គ្រង</h2>
					<p>សូមបញ្ចូលព័ត៌មានគណនីរបស់អ្នកដើម្បីបន្ត</p>
				</div>

				<form @submit.prevent="login" novalidate>
					<label class="field-label" for="username">ឈ្មោះអ្នកប្រើប្រាស់</label>
					<div class="input-shell">
						<i class="material-icons">person_outline</i>
						<input
							id="username"
							ref="username"
							v-model.trim="user.username"
							type="text"
							autocomplete="username"
							placeholder="បញ្ចូលឈ្មោះអ្នកប្រើប្រាស់"
							:disabled="submitting"
						>
					</div>

					<label class="field-label" for="password">ពាក្យសម្ងាត់</label>
					<div class="input-shell">
						<i class="material-icons">lock_outline</i>
						<input
							id="password"
							v-model="user.password"
							:type="showPassword ? 'text' : 'password'"
							autocomplete="current-password"
							placeholder="បញ្ចូលពាក្យសម្ងាត់"
							:disabled="submitting"
						>
						<button class="password-toggle" type="button" :aria-label="showPassword ? 'លាក់ពាក្យសម្ងាត់' : 'បង្ហាញពាក្យសម្ងាត់'" @click="showPassword = !showPassword">
							<i class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
						</button>
					</div>

					<button class="login-button" type="submit" :disabled="submitting">
						<span v-if="submitting" class="button-loader"></span>
						<span>{{ submitting ? 'កំពុងចូលប្រព័ន្ធ…' : 'ចូលប្រព័ន្ធ' }}</span>
						<i v-if="!submitting" class="material-icons">arrow_forward</i>
					</button>
				</form>

				<p class="security-note"><i class="material-icons">shield</i> សម័យប្រើប្រាស់របស់អ្នកត្រូវបានការពារ និងផ្ទៀងផ្ទាត់ដោយសុវត្ថិភាព។</p>
			</div>

			<footer>© {{ currentYear }} SabayFlix · ប្រព័ន្ធគ្រប់គ្រង</footer>
		</section>
	</main>
</template>

<script>
	export default {
		data() {
			return {
				user: {
					username: "",
					password: ""
				},
				showPassword: false,
				submitting: false,
				currentYear: new Date().getFullYear()
			}
		},
		mounted() {
			this.$nextTick(() => this.$refs.username.focus())
		},
		methods: {
			login() {
				if (this.submitting || !this.checkValidation()) return

				this.submitting = true
				const username = this.user.username
				const password = this.user.password

				this.$http.post(this.config.api + "/user/login", { username, password }).then(res => {
					if (res.body.status === 'success') {
						this.$store.state.authentication.loggedIn = true
						this.$store.state.authentication.authToken = res.body.data.token
						this.$store.state.authentication.user_hash = res.body.data.hash
						this.$store.state.authentication.user_name = res.body.data.name
						this.$store.state.authentication.user_role = res.body.data.role
						this.$cookie.set('auth', res.body.data.token, 10)
					}
				}).catch(() => {
					this.$notification.notify({
						message: "មិនអាចចូលប្រព័ន្ធបានទេ។ សូមព្យាយាមម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
				}).then(() => {
					this.submitting = false
				})
			},
			checkValidation() {
				if (this.user.username.length < 3 || this.user.password.length < 6) {
					this.$notification.notify({
						message: "សូមបំពេញឈ្មោះអ្នកប្រើប្រាស់ និងពាក្យសម្ងាត់ឱ្យបានត្រឹមត្រូវ។",
						icon: 'error',
						type: 'danger'
					})
					return false
				}

				return true
			}
		}
	}
</script>

<style scoped>
	.login-page {
		--red: #e00000;
		--red-light: #ff3d45;
		position: fixed;
		inset: 0;
		display: grid;
		grid-template-columns: minmax(420px, 1.12fr) minmax(440px, .88fr);
		min-height: 100vh;
		overflow: auto;
		background: #080b13;
		font-family: "Hanuman", "Open Sans", sans-serif;
	}

	.brand-panel {
		position: relative;
		display: flex;
		min-height: 100vh;
		padding: 54px clamp(48px, 6vw, 100px);
		overflow: hidden;
		color: #fff;
		background:
			radial-gradient(circle at 18% 75%, rgba(224, 0, 0, .24), transparent 32%),
			linear-gradient(145deg, rgba(15, 20, 34, .96), rgba(5, 8, 15, .98));
	}

	.brand-panel::after {
		content: "";
		position: absolute;
		right: -130px;
		top: 12%;
		width: 330px;
		height: 330px;
		border: 1px solid rgba(255, 255, 255, .05);
		border-radius: 50%;
		box-shadow: 0 0 0 75px rgba(255, 255, 255, .018), 0 0 0 150px rgba(255, 255, 255, .012);
		animation: breathe 7s ease-in-out infinite;
	}

	.brand-content {
		position: relative;
		z-index: 3;
		display: flex;
		flex: 1;
		flex-direction: column;
		max-width: 650px;
	}

	.brand-mark,
	.mobile-brand {
		display: flex;
		align-items: center;
		gap: 18px;
	}

	.brand-mark img { width: 225px; height: auto; }
	.brand-mark span,
	.mobile-brand span {
		padding: 6px 9px;
		border: 1px solid rgba(255, 255, 255, .16);
		border-radius: 5px;
		color: #aab0bd;
		font-size: 9px;
		font-weight: 700;
		letter-spacing: 1.6px;
	}

	.hero-copy { margin: auto 0; }
	.eyebrow {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 23px;
		color: #aeb5c4;
		font-size: 12px;
		font-weight: 600;
		letter-spacing: 1.3px;
	}
	.eyebrow i { width: 28px; height: 2px; background: var(--red); }
	.hero-copy h1 {
		margin: 0;
		font-size: clamp(42px, 5vw, 70px);
		font-weight: 300;
		line-height: 1.08;
		letter-spacing: -1px;
	}
	.hero-copy h1 strong { color: var(--red-light); font-weight: 750; }
	.hero-copy p {
		max-width: 520px;
		margin: 28px 0 0;
		color: #939aa9;
		font-size: 16px;
		line-height: 1.8;
	}

	.system-status { display: flex; align-items: center; gap: 13px; color: #d7dae1; }
	.system-status strong { display: block; font-size: 12px; letter-spacing: .2px; }
	.system-status small { display: block; margin-top: 3px; color: #707887; font-size: 10px; }
	.status-dot {
		width: 9px;
		height: 9px;
		border-radius: 50%;
		background: #38d996;
		box-shadow: 0 0 0 5px rgba(56, 217, 150, .1), 0 0 16px rgba(56, 217, 150, .45);
		animation: statusPulse 2.2s ease-out infinite;
	}

	.form-panel {
		position: relative;
		z-index: 5;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 100vh;
		padding: 60px clamp(35px, 6vw, 105px) 38px;
		background: #f7f8fb;
	}

	.login-card { width: 100%; max-width: 430px; }
	.mobile-brand { display: none; margin-bottom: 55px; }
	.mobile-brand img { width: 178px; }
	.mobile-brand span { border-color: #d8dae1; color: #747986; }
	.form-heading { margin-bottom: 38px; }
	.form-kicker { color: var(--red); font-size: 10px; font-weight: 800; letter-spacing: 2.2px; }
	.form-heading h2 { margin: 10px 0 9px; color: #121722; font-size: 30px; font-weight: 720; letter-spacing: -.8px; }
	.form-heading p { margin: 0; color: #89909d; font-family: "Hanuman", sans-serif; font-size: 13px; }

	.field-label { display: block; margin: 0 0 9px; color: #343a47; font-size: 11px; font-weight: 700; letter-spacing: .35px; }
	.input-shell {
		display: flex;
		align-items: center;
		height: 54px;
		margin-bottom: 23px;
		padding: 0 15px;
		border: 1px solid #dfe2e8;
		border-radius: 9px;
		background: #fff;
		box-shadow: 0 2px 8px rgba(20, 27, 45, .025);
		transition: border-color .2s, box-shadow .2s, transform .2s;
	}
	.input-shell:focus-within { border-color: rgba(224, 0, 0, .55); box-shadow: 0 0 0 4px rgba(224, 0, 0, .07); transform: translateY(-1px); }
	.input-shell > i { margin-right: 12px; color: #a6abb5; font-size: 20px; }
	.input-shell input {
		min-width: 0;
		width: 100%;
		height: 100%;
		border: 0;
		outline: 0;
		background: transparent;
		color: #171b25;
		font: 500 13px "Hanuman", "Open Sans", sans-serif;
	}
	.input-shell input::placeholder { color: #b0b5bf; }
	.password-toggle { display: flex; padding: 7px; border: 0; outline: 0; background: transparent; color: #a6abb5; cursor: pointer; }
	.password-toggle:hover { color: var(--red); }
	.password-toggle i { font-size: 19px; }

	.login-button {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 12px;
		width: 100%;
		height: 54px;
		margin-top: 34px;
		border: 0;
		border-radius: 9px;
		background: linear-gradient(135deg, #ec1018, #c80000);
		box-shadow: 0 10px 25px rgba(204, 0, 0, .22);
		color: #fff;
		font: 700 13px "Hanuman", "Open Sans", sans-serif;
		cursor: pointer;
		transition: transform .2s, box-shadow .2s, filter .2s;
	}
	.login-button:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 14px 32px rgba(204, 0, 0, .3); filter: brightness(1.04); }
	.login-button:disabled { cursor: wait; opacity: .75; }
	.login-button i { font-size: 18px; }
	.button-loader { width: 17px; height: 17px; border: 2px solid rgba(255, 255, 255, .35); border-top-color: #fff; border-radius: 50%; animation: spin .7s linear infinite; }
	.security-note { display: flex; align-items: center; justify-content: center; gap: 7px; margin: 28px 0 0; color: #9da2ad; font-size: 10px; }
	.security-note i { color: #aeb3bc; font-size: 14px; }
	.form-panel footer { position: absolute; bottom: 22px; color: #abb0ba; font-size: 9px; letter-spacing: .4px; }

	.console-grid {
		position: fixed;
		z-index: 2;
		left: 0;
		bottom: 0;
		display: grid;
		grid-template-columns: repeat(6, 38px);
		gap: 14px;
		width: 52%;
		height: 44%;
		padding: 50px;
		opacity: .32;
		transform: perspective(500px) rotateX(58deg) rotateZ(-24deg) translate(-40px, 110px);
		transform-origin: bottom left;
	}
	.grid-node {
		width: 9px;
		height: 9px;
		border: 1px solid rgba(255, 70, 76, .8);
		background: rgba(224, 0, 0, .18);
		box-shadow: 0 0 10px rgba(224, 0, 0, .35);
		animation: nodeFloat 4s ease-in-out infinite;
	}
	.grid-node:nth-child(3n) { animation-delay: -1.3s; }
	.grid-node:nth-child(4n) { animation-delay: -2.6s; transform: scale(1.8); }

	.ambient { position: fixed; z-index: 1; border-radius: 50%; filter: blur(2px); pointer-events: none; }
	.ambient-one { left: 39%; top: 14%; width: 6px; height: 6px; background: #ff3840; box-shadow: 0 0 24px 8px rgba(224, 0, 0, .2); animation: drift 8s ease-in-out infinite; }
	.ambient-two { left: 11%; top: 27%; width: 3px; height: 3px; background: #fff; box-shadow: 0 0 16px 4px rgba(255, 255, 255, .12); animation: drift 11s ease-in-out -3s infinite reverse; }

	@keyframes spin { to { transform: rotate(360deg); } }
	@keyframes breathe { 50% { transform: scale(1.06); opacity: .7; } }
	@keyframes statusPulse { 70% { box-shadow: 0 0 0 9px rgba(56, 217, 150, 0), 0 0 16px rgba(56, 217, 150, .4); } }
	@keyframes nodeFloat { 50% { transform: translateY(-12px) scale(1.35); opacity: .35; } }
	@keyframes drift { 50% { transform: translate(80px, 45px); opacity: .4; } }

	@media (max-width: 900px) {
		.login-page { display: block; background: #f7f8fb; }
		.brand-panel, .console-grid, .ambient { display: none; }
		.form-panel { min-height: 100vh; padding: 46px 28px 50px; }
		.mobile-brand { display: flex; }
		.login-card { max-width: 480px; }
	}

	@media (max-width: 480px) {
		.form-panel { align-items: flex-start; padding-top: 34px; }
		.mobile-brand { margin-bottom: 55px; }
		.mobile-brand img { width: 164px; }
		.form-heading h2 { font-size: 27px; }
		.input-shell, .login-button { height: 52px; }
		.form-panel footer { display: none; }
	}

	@media (prefers-reduced-motion: reduce) {
		*, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; }
	}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue